module.exports = __webpack_public_path__ + "img/label1.eb47d948.png";